import { createAction } from 'redux-actions';

export const startEditNotesSubmit = createAction('START_EDIT_NOTES_SUBMIT');

export const resolveEditSubmit = createAction('RESOLVE_EDIT_NOTES_SUBMIT');

export const getShareLink = createAction('GET_RECRUITER_NOTES');
